/* import __COLOCATED_TEMPLATE__ from './attribute-summaries.hbs'; */
/* RESPONSIBLE TEAM: team-ai-insights */
import Component from '@glimmer/component';
import type { Job } from 'embercom/components/reporting/automation/ai-insights/optimize/jobs';
import { type LogicalFilter } from 'embercom/components/reporting/custom/filters';
import type Range from 'embercom/models/reporting/range';
import { type SummaryTab } from './conversation-explore-panel';
import { use } from 'ember-resources/util/function-resource';
import { staticDataResource } from 'embercom/lib/reporting/static-data-resource';
import { type ReportState } from 'embercom/components/reporting/custom/report/chart-card';
import type { ChartSeriesDefinition } from 'embercom/components/reporting/automation/ai-insights/fin-insights/jobs';

interface Signature {
  Args: {
    selectedJob: Job;
    dateRange: Range;
    onShowConversationExplorer: (
      selectedConversationId: number | null,
      filters: LogicalFilter,
      attributeValuesToExplore: string[],
      summaryType: SummaryTab,
      summaryText: string,
      summaryHeading?: string,
    ) => void;
    reportState: ReportState;
  };
}

export default class AttributeSummaries extends Component<Signature> {
  @use metricResource = staticDataResource(this, {
    serializedChart: () => this.chartDefinition,
    reportState: () => this.args.reportState,
  });

  get isLoading() {
    return this.metricResource.isLoading;
  }

  get chartDefinition() {
    return {
      view_by_other: false,
      view_by_display_limit: 5,
      view_by: this.args.selectedJob.breakdownByAttributeId,
      chart_series: this.args.selectedJob.chartSeries.map((series: ChartSeriesDefinition) => ({
        ...series,
        filters: this.args.selectedJob.filters,
      })),
    };
  }

  get breakdownAttributeValues() {
    return Object.keys(this.metricResource.flatCombinedData);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::Optimize::AttributeSummaries': typeof AttributeSummaries;
    'reporting/automation/ai-insights/optimize/attribute-summaries': typeof AttributeSummaries;
  }
}
